"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinearLoader = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = require("../../utils/classify");
var _LinearLoaderModule = _interopRequireDefault(require("./LinearLoader.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const LinearLoader = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    value,
    size = 'medium',
    className,
    indeterminate
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.classify)(_LinearLoaderModule.default.lineContainer, {
      [_LinearLoaderModule.default.large]: size === 'large',
      [_LinearLoaderModule.default.medium]: size === 'medium',
      [_LinearLoaderModule.default.small]: size === 'small'
    }, className),
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.classify)(_LinearLoaderModule.default.progressBar, {
      [_LinearLoaderModule.default.indeterminate]: indeterminate
    }),
    style: {
      width: `${value + '%'}`
    },
    role: "progressbar",
    "aria-valuenow": indeterminate ? undefined : value,
    "aria-valuemin": "0",
    "aria-valuemax": "100"
  }));
});
exports.LinearLoader = LinearLoader;